import React from "react";
import { string, arrayOf, shape } from "prop-types";

import FeaturedContentCard from "./FeaturedContentCard/FeaturedContentCard.jsx";

const FeaturedContent = (props) => {
  const { featuredLinks } = props;

  if (!featuredLinks && featuredLinks.length < 1) {
    return null;
  }

  return (
    <ul className="featured-content__list">
      {featuredLinks.map((group, i) => {
        return <FeaturedContentCard key={i} {...group} />;
      })}
    </ul>
  );
};

FeaturedContent.propTypes = {
  featuredLinks: arrayOf(
    shape({
      href: string,
      topic: string,
      title: string,
      subtitle: string,
    }),
  ),
};
export default FeaturedContent;
